var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _path10, _ellipse2, _path11, _path12, _path13, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEcuador(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C23",
    d: "M36 27a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#034EA2",
    d: "M0 17h36v7H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD0",
    d: "M36 17V9a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v8h36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD0",
    d: "M23 19a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#034EA2",
    d: "M22 18c0 1.104-.896 3-2 3h-4c-1.104 0-2-1.896-2-3v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C23",
    d: "M21 18c0 1.104-.896 3-2 3h-2c-1.104 0-2-1.896-2-3v-1a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6DBE46",
    d: "M19.973 14.135c-.133.488-.961.865-1.973.865s-1.84-.377-1.973-.865C14.822 14.307 15 14.628 15 15c0 .552.791 1 3 1s3-.448 3-1c0-.372.178-.693-1.027-.865z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6D388",
    d: "M19 19a1 1 0 1 1-2 0v-3a1 1 0 0 1 2 0v3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M21.5 12c.44 0 .858.052 1.246.137C22.123 11.061 20 10 18 12c-2-2-4.123-.939-4.746.137A5.822 5.822 0 0 1 14.5 12c1.933 0 3.5.896 3.5 2c0-1.104 1.566-2 3.5-2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8ED2E7",
    cx: 18,
    cy: 17.5,
    rx: 2,
    ry: 3.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6DBE46",
    d: "M17.5 17c-.536 0-1.037.13-1.491.345c-.001.052-.009.102-.009.155c0 1.933.896 3.5 2 3.5c1.003 0 1.825-1.295 1.97-2.979A3.492 3.492 0 0 0 17.5 17z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFCC4D",
    cx: 18,
    cy: 22,
    rx: 3,
    ry: 1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#034EA2",
    d: "M20 23c0 .828-.896 1-2 1s-2-.172-2-1s.896-2 2-2s2 1.172 2 2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C23",
    d: "M17 23c0-.828.448-2 1-2s1 1.172 1 2s-.448 1-1 1s-1-.172-1-1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD6DD",
    d: "M17 11c0-.552.448 0 1 0s1-.552 1 0a1 1 0 0 1-2 0z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 18,
    cy: 17.5,
    rx: 1,
    ry: 0.5
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C1694F",
    cx: 13,
    cy: 15.5,
    rx: 1,
    ry: 0.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C1694F",
    cx: 14,
    cy: 13.5,
    rx: 1,
    ry: 0.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C1694F",
    cx: 23,
    cy: 15.5,
    rx: 1,
    ry: 0.5
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C1694F",
    cx: 22,
    cy: 13.5,
    rx: 1,
    ry: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcuador);
export default __webpack_public_path__ + "static/media/ecuador.9d03bbc2d0306ded294d9dbc7c926268.svg";
export { ForwardRef as ReactComponent };